import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Security from "../Pages/Company/Security";
import Settings from "../Pages/Company/Settings";
import Users from "../Pages/Company/Users";

const CompanyRoutes = ({ setFlag }) => {
  return (
    <Routes>
      <Route path="/general" element={<Users setFlag={setFlag} />} />
      <Route path="/security" element={<Security />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="*" element={<Navigate to={"/general"} />} />
    </Routes>
  );
};

export default CompanyRoutes;
